import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MAIN_SITE_URL } from '@/data/site';

interface FaqItem {
  q: string;
  a: string;
}

export default function FaqSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const items = t('home.faq.items', { returnObjects: true }) as unknown as FaqItem[];

  return (
    <section className="w-full bg-background-100">
      <div className="mx-auto max-w-3xl px-4 py-16 md:px-6 md:py-20">
        <h2 className="text-center font-heading text-2xl font-semibold text-foreground-950 md:text-3xl">
          {t('home.faq.title')}
        </h2>

        <div className="mt-10 space-y-3">
          {items.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={item.q} className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                >
                  <span className="text-sm font-medium text-foreground-950 md:text-base">{item.q}</span>
                  <i
                    className={`ri-add-line text-lg leading-none text-foreground-500 transition-transform ${
                      isOpen ? 'rotate-45' : ''
                    }`}
                  ></i>
                </button>
                {isOpen && (
                  <div className="px-5 pb-4">
                    <p className="text-sm leading-relaxed text-foreground-700">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div className="mt-14 rounded-lg bg-primary-950 px-6 py-10 text-center md:px-10">
          <h3 className="font-heading text-2xl font-semibold text-white md:text-3xl">
            {t('home.finalCta.title')}
          </h3>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-primary-100/90 md:text-base">
            {t('home.finalCta.subtitle')}
          </p>
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="mt-6 inline-flex whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-primary-600"
          >
            {t('buttons.visitMainSite')}
          </a>
        </div>
      </div>
    </section>
  );
}